<template>
  <div class="auction-detail">
    <div class="breadcrumb_section bg_gray page-title-mini">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6">
            <div class="page-title">
              <h1>{{ auctionData.name }}</h1>
            </div>
          </div>
          <div class="col-md-6">
            <ol class="breadcrumb justify-content-md-end">
              <li class="breadcrumb-item"><a href="/">Home</a></li>
              <li class="breadcrumb-item active">{{ auctionData.name }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <div class="panel mt-3">
            <div class="panel-heading">
              Thông tin đấu giá
            </div>
            <div class="panel-body">
              <p>Tên phiên: <strong>{{ auction.name }}</strong></p>
              <p v-if="auction.auction_type === 0">Loại dấu giá: <strong>Ngược</strong></p>
              <p v-else>Loại dấu giá: <strong>Xuôi</strong></p>
              <p>Tình trạng: <strong>{{ auction.status }}</strong></p>
              <p>Số tiền cược tối thiểu: <strong>{{ auction.min_price_per_bid }} đ</strong></p>
              <p v-if="auction.reverse_fee > 0">Phí đặt cược: <strong>{{ auction.reverse_fee }} đ</strong>
              </p>
              <p>Số người tham gia: <strong>{{ player_count }}</strong></p>
              <p v-if="checkStart(auction.start_at)">Bắt đầu lúc: <strong>{{
                  formatDate(auction.start_at)
                }}</strong>
              </p>
              <div class="text-center">
                <div class="row">
                  <div class="col-md-6 col-xs-12" v-if="now < auction.start_at">
                    <h6>Phiên đấu giá còn</h6>
                    <div class="countdown-wrap">
                      <vue-countdown :time="getTimeCountDown(auction)"
                                     v-slot="{ days, hours, minutes, seconds }">
                        {{ days }} ngày {{ hours }} giờ, {{ minutes }} phút, {{ seconds }} giây.
                      </vue-countdown>
                    </div>
                  </div>
                  <div class="col-md-6 col-xs-12" v-if="dataBid && dataBid != 'null'">
                    <h6>
                      {{
                        auction.auction_type == 0 ? 'Mức giá thấp nhất hiện tại' : 'Mức giá cao nhất hiện tại'
                      }}</h6>
                    <div class="countdown-wrap">
                      {{ Helper.formatMoney(dataBid) }} đ
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="panel mt-3">
            <div class="panel-heading">
              Đặt cược
            </div>
            <div class="panel-body">
              <div class="form-group">
                <input type="number" v-model="bidPrice" class="form-control"
                       placeholder="Vui lòng nhập giá muốn đấu"/>
              </div>
              <div class="form-group">
                <button @click="bid()" style="width: 100%" class="btn btn-danger">Đấu giá ngay</button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 mt-3">
          <div class="panel">
            <div class="panel-heading">
              Box chat
            </div>
            <div class="panel-body" style="padding-bottom: 0;">
              <ul class="box-chat-message list-unstyled" style="min-height: 450px">
                <li v-if="messages.length < 1" class="message-item">Hãy là người đầu tiên đấu giá phiên
                  này
                </li>
                <li class="message-item" v-else v-for="message in messages"
                    :key="`message-${message.id}`">
                  <strong>{{ message.user.name }}:</strong>{{ message.message }}
                </li>
              </ul>
              <div class="form-inline"
                   style="margin-left: -10px;margin-right: -10px; background:#ff7e23; padding: 15px;">
                <div class="form-group" style="width: 80%;">
                  <input type="text" v-model="messageText" v-on:keyup.enter="sendChat"
                         class="form-control" style="width: 100%;padding:5px;" id="mesage"
                         placeholder="Hello anh em...">
                </div>
                <button role="button" :disabled="isLoading" @click="sendChat" type="submit"
                        class="btn btn-primary btn-danger">Gửi
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 mt-3">
          <h2 class="text-center"> Thông tin phiên </h2>
          <div v-html="auction.account_description"></div>
        </div>
        <div class="col-md-12">
          <h2 class="text-center">Các phiên đấu giá khác</h2>
          <carousel :perPageCustom="[[768, 3], [1024, 4]]">
            <slide v-for="(auctionItem, index) in auctions" :key="`auction-${index}`">
              <div class="product_box text-center" style="margin: 15px;">
                <div class="product_img">
                  <a :href="route('auction.show', { slug: `${auctionItem.name}-${auctionItem.id}`, domain: host })">
                    <img :alt="auctionItem.name"
                         :data-src="auctionItem.image"
                         :src="auctionItem.image"
                         lazy="loaded">
                  </a>
                </div>
                <div class="product_info"><h6 class="product_title">
                  <a>{{ auctionItem.name }}</a>
                </h6>
                  <div class="product_price">
                    {{ auctionItem.status }}
                  </div>
                  <div class="rating_wrap">
                    <div class="rating">
                      <div class="product_rate" style="width: 100%;"></div>
                    </div>
                    <br>
                    <a v-if="auctionItem.start_at < now && canBid(auctionItem)"
                       :href="route('auction.show', { slug: `${auctionItem.name}-${auctionItem.id}`, domain: host })"
                       class="btn btn-fill-out btn-radius">
                      <vue-countdown v-if="canBid(auctionItem) > 1"
                                     :time="canBid(auctionItem) * 1000"
                                     v-slot="{ days, hours, minutes, seconds }">
                        {{ days }}D, {{ hours }}H, {{ minutes }}M, {{ seconds }}S.
                      </vue-countdown>
                      <span v-else>Tham gia ngay</span>
                    </a>
                  </div>
                </div>
              </div>
            </slide>
          </carousel>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import dayjs from "dayjs";
import VueCountdown from '@chenfengyuan/vue-countdown';
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import clone from 'lodash/clone'
import Swal from "sweetalert2";

dayjs.extend(utc)
dayjs.extend(timezone)

export default {
  name: "AuctionDetail",
  props: {
    auction: {
      Type: Object,
      default() {
        return {};
      }
    },
    auctions: {
      Type: Object,
      default() {
        return {};
      }
    },
    winner: {
      Type: Object,
      default() {
        return {};
      }
    },
    dataBid: {
      Type: Number,
      default() {
        return 0;
      }
    },
    info: {
      Type: String,
      default() {
        return null;
      }
    },
    status: {
      Type: Boolean,
      default() {
        return false;
      }
    },
    chatMessages: {
      Type: Array,
      default() {
        return [];
      }
    },
    color: Math.floor(Math.random() * 16777215).toString(16),

  },
  components: {
    VueCountdown
  },
  data() {
    return {
      bidPrice: 1000,
      currentUrl: location.toString(),
      auctionData: {},
      now: dayjs().unix(),
      history: [],
      host: location.host,
      messageText: "",
      player_count: 0,
      isLoading: false,
      messages: []
    }
  },
  mounted() {
    this.bidPrice = this.auction.min_price_per_bid;
    this.auctionData = clone(this.auction);
    this.messages = clone(this.chatMessages)
    this.fetchInfo();
    if (this.now < this.auction.end_at) {
      setInterval(() => {
        this.fetchInfo();
        this.now = dayjs().unix()
      }, 2000)
    }
  },
  methods: {
    formatDate(end_date) {
      const date = dayjs.unix(end_date)
      return date.format('DD/MM/YYYY HH:MM A');
    },
    getTimeCountDown(auction) {
      const now = dayjs().unix();
      return (auction.end_at - now) * 1000
    },
    checkStart(start_time) {
      const now = dayjs().unix();
      if (now < start_time)
        return true

      return false
    },
    canBid(auction) {
      const now = dayjs().unix();
      if (now > auction.end_at) {
        return false
      } else if (now < auction.end_at && now > auction.start_at) {
        return true
      } else {
        return auction.end_at - now
      }
    },
    async fetchInfo() {
      const uri = this.route('auction.info', {auction: this.auction.id, domain: this.host});
      const res = await fetch(uri, {
        method: "GET",
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        }
      });
      const json = await res.json()
      this.auctionData = json.auctionInfo;
      this.history = json.transactionHistory;
      this.messages = json.messages
      this.player_count = json.auctionInfo.player_count
      this.dataBid = json.dataBid

    },
    async bid() {
      if (this.bidPrice < this.auction.min_price_per_bid || (this.bidPrice % 1000) !== 0) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Giá đấu cần lớn hơn hoặc bằng ' + this.auction.min_price_per_bid + 'và là bội số của 1000',
        });
        return
      }
      const uri = this.route('auction.bid', {auction: this.auction.id, domain: this.host});
      const res = await fetch(uri, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({bidPrice: this.bidPrice})
      });
      const json = await res.json()
      await Swal.fire({
        icon: (json.success) ? 'success' : 'error',
        title: (json.success) ? 'Thành công' : 'Lỗi',
        text: json.message
      });
      await this.fetchInfo();
    },
    async request(uri, init = {}) {
      try {
        const res = await fetch(uri, {
          method: "GET",
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
          },
          ...init
        });
        return await res.json();
      } catch (e) {
        await Swal.fire({
          icon: 'error',
          title: 'Lỗi',
          text: e.toString()
        });
      }
    },
    async sendChat() {
      this.isLoading = true
      const uri = this.route('auction.chat', {
        domain: this.host,
        auction: this.auction.id
      })

      await this.request(uri, {
        method: "POST",
        body: JSON.stringify({
          message: this.messageText
        })
      })
      this.messageText = ''
      this.isLoading = false;
      await this.fetchInfo();
    },
    async onEnter(e) {
      console.log(e.key, e.keyCode)
    }
  }
}
</script>
<style lang="scss">
.info-auction p {
  margin-bottom: 1rem;
}

.panel {
  .panel-heading {
    background: #ff7e23;
    color: #fff;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    padding: 10px;
  }

  .panel-body {
    padding: 10px;
    border: 1px solid #ccc;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;

    * {
      line-height: 1;
    }

    .countdown-wrap {
      background: #ff7e23;
      padding: 10px;
      border-radius: 10px;
      font-size: 14px;
      color: #fff0ff;
    }

    .message-item {
      line-height: 1;
      margin-bottom: 10px;
    }
  }
}
</style>
